module.exports = __webpack_public_path__ + "static/media/location-maps-letter-h-arrow-serr2.107ac811.png";